import { UseCaseCard } from "../use-case-card"
import { getRelatedUseCases } from "@/data/use-cases-data"

interface RelatedUseCasesSectionProps {
  /** Slugs of related use cases to display */
  relatedSlugs: string[]
  /** Current use case slug to exclude from results */
  currentSlug: string
}

/**
 * Related Use Cases section showing related use case cards.
 * Displays up to 3 related use cases based on provided slugs.
 */
export function RelatedUseCasesSection({
  relatedSlugs,
  currentSlug,
}: RelatedUseCasesSectionProps) {
  // Get related use cases, excluding current
  const relatedUseCases = getRelatedUseCases(relatedSlugs).filter(
    (uc) => uc.slug !== currentSlug
  )

  if (relatedUseCases.length === 0) {
    return null
  }

  return (
    <section className="py-16 lg:py-24 bg-neutral-50">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-10 text-center">
          <h2 className="mb-4 text-2xl font-bold text-neutral-900 sm:text-3xl">
            Related Use Cases
          </h2>
          <p className="mx-auto max-w-2xl text-neutral-600">
            Explore other AI solutions that complement this use case.
          </p>
        </div>

        {/* Related Use Cases Grid */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {relatedUseCases.slice(0, 3).map((useCase, index) => (
            <UseCaseCard key={useCase.id} useCase={useCase} index={index} />
          ))}
        </div>
      </div>
    </section>
  )
}
